module.exports = __webpack_public_path__ + "static/media/custom_menu.5ca07806.svg";